var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-button",
    {
      staticClass: "button",
      attrs: { disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }